import { render, staticRenderFns } from "./candidate_age_study.vue?vue&type=template&id=25523584&scoped=true&"
import script from "./candidate_age_study.vue?vue&type=script&lang=js&"
export * from "./candidate_age_study.vue?vue&type=script&lang=js&"
import style0 from "./candidate_age_study.vue?vue&type=style&index=0&id=25523584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25523584",
  null
  
)

export default component.exports